module.exports = __webpack_public_path__ + "img/bg-careers-mobile.efe79ce9.png";